import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./routes/Routes";
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "./components/auth";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";

const hist = createBrowserHistory();

window.GLOBAL_HISTORY = hist;

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Router history={hist}>
        <Routes />
      </Router>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
